const template = require('./card-suggestion.tpl').default;

module.exports = DomClass(template, function() {
	this.toString = function() {
		return this.quantity + " " + this.name;
	};

	this.open = function() {
		this.__dom.href.open();
	};
});
